/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useContext } from 'react';
import { useTranslation } from 'next-i18next';

import { getErrorMessage } from '@utils/validation';

import {
  FormControl,
  RadioButton,
  RadiosWrapper,
  TextInput,
  InputsWrapper,
  SubSectionHeading,
} from '@common/components/forms';
import { GENDER_FEMALE, GENDER_MALE } from '@common/constants/genders';
import Hr from '@common/components/Hr';
import { FormContext } from '../../FormWrapper';

const SECTION_TRANSLATION_PREFIX =
  'mobile.orderForm.personalDetails.billingAddressSection';

const BillingPersonalFormSection = () => {
  const { formik, handleChange } = useContext(FormContext);
  const { t } = useTranslation();

  const { values, handleBlur, isSubmitting, touched, errors } = formik;

  return (
    <React.Fragment>
      <Hr spacings={['equal', 3]} />

      <SubSectionHeading spacingTop={['scale', 2]}>
        {t(`${SECTION_TRANSLATION_PREFIX}.title`, 'Rechnungsadresse')}
      </SubSectionHeading>

      <InputsWrapper>
        <FormControl
          label={t(`${SECTION_TRANSLATION_PREFIX}.genderLabel`, 'Anrede')}
          labelAs="span"
          hasError={
            touched.billing_address?.gender && !!errors.billing_address?.gender
          }
          message={
            touched.billing_address?.gender &&
            getErrorMessage(t, errors.billing_address?.gender)
          }
        >
          <RadiosWrapper>
            <RadioButton
              name="billing_address.gender"
              value={GENDER_FEMALE}
              text={t(
                `${SECTION_TRANSLATION_PREFIX}.genderFemaleLabel`,
                'Frau',
              )}
              checked={values.billing_address.gender === GENDER_FEMALE}
              onChange={handleChange}
              onBlur={handleBlur}
              disabled={isSubmitting}
            />
            <RadioButton
              name="billing_address.gender"
              value={GENDER_MALE}
              text={t(`${SECTION_TRANSLATION_PREFIX}.genderMaleLabel`, 'Herr')}
              checked={values.billing_address.gender === GENDER_MALE}
              onChange={handleChange}
              onBlur={handleBlur}
              disabled={isSubmitting}
            />
          </RadiosWrapper>
        </FormControl>
      </InputsWrapper>
      <InputsWrapper>
        <FormControl
          label={t(`${SECTION_TRANSLATION_PREFIX}.firstNameLabel`, 'Vorname')}
          hasError={
            touched.billing_address?.first_name &&
            !!errors.billing_address?.first_name
          }
          message={
            touched.billing_address?.first_name &&
            getErrorMessage(t, errors.billing_address?.first_name)
          }
        >
          <TextInput
            name="billing_address.first_name"
            value={values.billing_address.first_name}
            onChange={handleChange}
            onBlur={handleBlur}
            hasError={
              touched.billing_address?.first_name &&
              !!errors.billing_address?.first_name
            }
            type="text"
            placeholder={t(
              `${SECTION_TRANSLATION_PREFIX}.firstNamePlaceholder`,
              '',
            )}
            disabled={isSubmitting}
          />
        </FormControl>
        <FormControl
          label={t(`${SECTION_TRANSLATION_PREFIX}.lastNameLabel`, 'Nachname')}
          hasError={
            touched.billing_address?.last_name &&
            !!errors.billing_address?.last_name
          }
          message={
            touched.billing_address?.last_name &&
            getErrorMessage(t, errors.billing_address?.last_name)
          }
        >
          <TextInput
            name="billing_address.last_name"
            value={values.billing_address.last_name}
            onChange={handleChange}
            onBlur={handleBlur}
            hasError={
              touched.billing_address?.last_name &&
              !!errors.billing_address?.last_name
            }
            type="text"
            placeholder={t(
              `${SECTION_TRANSLATION_PREFIX}.lastNamePlaceholder`,
              '',
            )}
            disabled={isSubmitting}
          />
        </FormControl>
      </InputsWrapper>
    </React.Fragment>
  );
};

export default BillingPersonalFormSection;
